import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { AppState } from '../../bootstrap/redux/state/AppState';
import { getAppStore } from '../../bootstrap/redux/store/AppStore';
import { Messages } from '../../codegen/Localize';
import { IWebEditFlowAction } from '../../spacesPlatform/models/actionNames';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { editFlow } from '../actions/EditFlowReduxAction';
import { selectEditingFlowsEnabled } from '../selectors/FlowSelectors';

export const EditFlowEntityAction: IEntityAction<IContentInfo<'flow'>, IWebEditFlowAction> = {
  name: EntityActionNames.EditFlow,
  translateName: Messages.editFlow,
  isVisible: (_, state: AppState) => state ? selectEditingFlowsEnabled(state) : selectEditingFlowsEnabled(getAppStore().getState()),
  isClickable: (availableActions: IWebEditFlowAction) => !!availableActions && availableActions.webEditFlow,
  createReduxAction: (targetItems: IContentInfo[]) => editFlow(targetItems[0])
};
